import React, { useEffect, useState } from "react";
import "react-date-range/dist/styles.css"; // Main style file for react-date-range
import "react-date-range/dist/theme/default.css"; // Theme CSS file for react-date-range
import { useDispatch, useSelector } from "react-redux";
import CustomEmptyView from "../../../../Components/CustomEmptyView";
import Pagination from '../../../../Components/Pagination';
import Strings from "../../../../Config/Strings";
import { getOrderRolePermissions } from "../../../../Constants/PermissionConstant";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import OrderTableBody from "./OrderTableBody";
import OrderTableHeader from "./OrderTableHeader";
import Colors from "../../../../theme/Colors";

const OrderTable = ({
  orderData,
  onViewOrderDetails,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  totalItems,
  rowsPerPageOptions,
  rowsPerPageLabel,
  orderRolePermissions,
  onFilterChange,
}) => {

  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filters, setFilters] = useState({
    stateId: 0,
    cityId: 0,
    dateRange: { startDate: null, endDate: null },
  });
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  // // Update filters state when user changes filters
  // const handleFilterChange = useCallback(
  //   (newFilters) => {
  //     setFilters(newFilters);
  //     onFilterChange(newFilters); // Notify parent component of filter changes
  //   },
  //   [onFilterChange]
  // );

  const orderRoles = getOrderRolePermissions(orderRolePermissions);

  const onEditOrderDetails = (user) => {
  
  };

  const handleShowDeleteModal = (userId) => {
    setShowDeleteModal(true);
  };

  useEffect(() => {
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  return (
    <div style={mainContainer}>
      {/* Filter Component */}
      {/* <CustomFilterComponent
        filters={filters}
        open={isFilterOpen}
        onClose={() => setIsFilterOpen(!isFilterOpen)}
        onFilterChange={handleFilterChange} // Pass down the filter change handler
      /> */}

      {/* Order Table */}
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ height: "92%", minWidth: "110%" }}>
            {orderData?.length === 0 ||
            orderData?.length === undefined ||
            orderData?.length === null ? (
              <div style={{ width: "70vw" }}>
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <OrderTableHeader />
                  <OrderTableBody
                    orderData={orderData}
                    onViewOrderDetails={onViewOrderDetails}
                    onEditOrderDetails={onEditOrderDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                    onViewBtnShow={
                      userData?.data?.user_role_name === Strings.Admin
                        ? true
                        : orderRoles.viewOrderBtn
                    }
                    onEditBtnShow={
                      userData?.data?.user_role_name === Strings.Admin
                        ? true
                        : orderRoles.editOrderBtn
                    }
                    onDeleteBtnShow={
                      userData?.data?.user_role_name === Strings.Admin
                        ? true
                        : orderRoles.deleteOrderBtn
                    }
                  />
                </table>
              </>
            )}
          </div>

          {/* Pagination Component */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  borderRadius: "10px",
  height: "100%",
  margin: "0px 8px",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
};

const tableWrapper = {
  overflowY: "scroll",
  overflowX: "scroll",
  height: "100%",
};

const table = {
  minWidth: "105%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

export default OrderTable;
